import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { AuthenticatedComponent } from './authenticated.component';
import { HeaderComponent } from '../ui/header/header.component';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { AuthenticatedRoutingModule } from './authenticated-routing.module';
import { ShowUserOrganizationComponent } from '../ui/show-user-organization/show-user-organization.component';
import { UserMenuComponent } from '../ui/user-menu/user-menu.component';
import { SharedUtilPipesModule } from '@markant-platform/shared/util-pipes';
import { SharedLanguageSelectionFeatureModule } from '@markant-platform/shared/language-selection/feature';
import { HeaderNavigationComponent } from '../ui/header/header-navigation/header-navigation.component';
import { SharedSupportButtonModule } from '@markant-platform/shared/support-button';
import { SharedFooterModule } from '@markant-platform/shared/footer';
import { MobileMenuComponent } from '../ui/mobile-menu/mobile-menu.component';
import { SharedDialogFeatureModule } from '@markant-platform/shared/dialog/feature';
import { UserNotificationsComponent } from '../ui/user-notifications/user-notifications.component';
import { SharedGuidedTourModule } from '@markant-platform/shared/guided-tour';
import { NavigationComponent } from '@markant-platform/shared/navigation/feature';

@NgModule({
  imports: [
    CommonModule,
    AuthenticatedRoutingModule,
    MarkantElementsModule,
    TranslocoModule,
    SharedDialogFeatureModule,
    SharedUtilPipesModule,
    SharedLanguageSelectionFeatureModule,
    SharedSupportButtonModule,
    SharedFooterModule,
    UserNotificationsComponent,
    SharedGuidedTourModule,
    NavigationComponent,
    NgOptimizedImage,
  ],
  declarations: [
    AuthenticatedComponent,
    HeaderComponent,
    HeaderNavigationComponent,
    MobileMenuComponent,
    ShowUserOrganizationComponent,
    UserMenuComponent,
  ],
})
export class AuthenticatedModule {}
